// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorFields.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');

  var EditableInput = require('./Izenda.EditableInput');
  var ColorDialogUtils = require('./Izenda.ColorDialogUtils');

  var ColorFields = React.createClass({

    propTypes: {
      disabled: React.PropTypes.bool,
      onChange: React.PropTypes.func,
      rgb: React.PropTypes.object,
      hsv: React.PropTypes.object,
      hex: React.PropTypes.string
    },

    handleChange: function(data) {
      var onChange = this.props.onChange;
      var rgb = this.props.rgb;
      var hsv = this.props.hsv;
      const alpha = this.props.alpha;

      if (data['#']) {
        ColorDialogUtils.isValidHex(data['#']) && onChange({
          hex: data['#'],
          source: 'hex',
        });
      } else if (data.r || data.g || data.b || data.a) {
        onChange({
          r: data.r || rgb.r,
          g: data.g || rgb.g,
          b: data.b || rgb.b,
          source: 'rgb'
        },data.a || alpha);
      } else if (data.h || data.s || data.v) {
        onChange({
          h: data.h || hsv.h,
          s: data.s || hsv.s,
          v: data.v || hsv.v,
          source: 'hsv'
        });
      }
    },

    render: function() {
      var rgb = this.props.rgb;
      var hsv = this.props.hsv;
      var hex = this.props.hex;
      const alpha = this.props.alpha;
      
      return (
        <div className="izenda-ColorFields">
          <EditableInput
            label="h"
            value={ Math.round(hsv.h) }
            onChange={ this.handleChange }
          />
          <EditableInput
            label="s"
            value={ Math.round(hsv.s * 100) }
            onChange={ this.handleChange }
          />
          <EditableInput
            label="v"
            value={ Math.round(hsv.v * 100) }
            onChange={ this.handleChange }
          />
          <div className="izenda-ColorFields-divider" />
          <EditableInput
            label="r"
            value={ rgb.r }
            onChange={ this.handleChange }
          />
          <EditableInput
            label="g"
            value={ rgb.g }
            onChange={ this.handleChange }
          />
          <EditableInput
            label="b"
            value={ rgb.b }
            onChange={ this.handleChange }
          />
           {this.props.isAlpha && <EditableInput
            label='a'
            value={ alpha }
            onChange={ this.handleChange }
          />}
          <div className="izenda-ColorFields-divider" />
          <EditableInput
            type="hex"
            label="#"
            value={ hex.replace('#', '') }
            onChange={ this.handleChange }
          />
          <div className="izenda-ColorFields-fieldSymbols">
            <div className="izenda-ColorFields-symbol">°</div>
            <div className="izenda-ColorFields-symbol">%</div>
            <div className="izenda-ColorFields-symbol">%</div>
          </div>
        </div>
      );
    }
  });

  module.exports = ColorFields;

}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/ColorDialog/Izenda.ColorFields.jsx